/**
 *
 * Retrieves the data for a fragment of an article
 *
 * - If an article id is passed in then that will be used to look up the relevant article.
 * - Otherwise it will return the article in the surrounding ArticleFragmentContext otherwise if that isn't set the ArticleContext will be tried.
 *
 * > **💡 NOTE**: If no matching article fragment can be found undefined is returned
 *
 * <div style="display:none">⏳ TODO confirm this is a good description</div>
 *
 *  @module
 */
import { useContext } from 'react';
import { HomeContext, CategoryContext, ArticleContext, ArticleFragmentContext, } from '../contexts';
/**
 *
 * # useArticleFragment
 *
 * Example usage:
 *
 * ```javascript
 * import useArticleFragment from "@elevio/kb-kit/lib/hooks/useArticleFragment";
 *
 * export const MyComponent = ({ articleId }) => {
 *   const article = useArticleFragment(articleId);
 *   console.log(article); // IArticleFragment | undefined
 *
 *   return (
 *     ...
 *   );
 * };
 * ```
 */
export default function useArticleFragment(articleId) {
    const fragment = useContext(ArticleFragmentContext);
    const article = useContext(ArticleContext);
    const category = useContext(CategoryContext);
    const home = useContext(HomeContext);
    if (!articleId) {
        if (fragment)
            return fragment;
        if (article) {
            return {
                id: article.id,
                title: article.title,
                slug: article.slug,
                summary: article.summary,
                categoryId: article.category.id,
            };
        }
        return undefined;
    }
    if (fragment && fragment.id === articleId)
        return fragment;
    if (article && article.id === articleId)
        return {
            id: article.id,
            title: article.title,
            slug: article.slug,
            summary: article.summary,
            categoryId: article.category.id,
        };
    if (category) {
        const _article = category.articles.results.find((a) => a.id === articleId);
        if (_article) {
            return {
                id: _article.id,
                title: _article.title,
                slug: _article.slug,
                summary: _article.summary,
                categoryId: category.id,
            };
        }
    }
    if (home && home.categories) {
        const categories = home.categories;
        let _article;
        for (const cat of categories) {
            _article = cat.articles.results.find((a) => a.id === articleId);
            if (_article) {
                return {
                    id: _article.id,
                    title: _article.title,
                    slug: _article.slug,
                    summary: _article.summary,
                    categoryId: cat.id,
                };
            }
        }
    }
    return undefined;
}
//# sourceMappingURL=useArticleFragment.js.map